import videojs from 'video.js';
import getIconClose from '../templates/icon-close.svg.html';

const Component = videojs.getComponent('Component');

class Popup extends Component {
	/**
	 * @constructor
	 * @param {videojs.Player} player - The video player instance.
	 * @param {Object} options - The options for the Popup plugin.
	 * @param {Function} [options.onShow]
	 * @param {Function} [options.onHide]
	 * @param {string} [options.className]
	 */
	constructor(player, options) {
		super(player, options);

		this._settingsNamesContainer = null;
		this._settingsListsContainer = null;

		this.hide();
		this._addChildren();
	}

	_addChildren() {
		const buttonClose = this.addChild('ClickableComponent', {
			className: `${this.options_.className}-close`,
			controlText: 'Close',
			clickHandler: () => {
				this.hide();
				this._settingsNamesContainer.show();
				this._settingsListsContainer.children().forEach((child) => !child.isDisposed() && child.hide());
			}
		});
		buttonClose.$('.vjs-icon-placeholder').innerHTML = getIconClose();

		const body = this.addChild('Component', {
			className: `${this.options_.className}-body`
		});

		this._settingsNamesContainer = body.addChild('Component', {
			className: `${this.options_.className}-settings-names`
		});

		const title = this._settingsNamesContainer.addChild('Component', {
			className: `${this.options_.className}-title`
		});
		title.el().innerText = this.localize('Settings');

		this._settingsListsContainer = body.addChild('Component', {
			className: `${this.options_.className}-settings-lists`
		});
	}

	addSettingsList(items, isHidden = true) {
		const settingsList = this._settingsListsContainer.addChild('Component', {
			className: `${this.options_.className}-settings-list`
		});

		if (isHidden) {
			settingsList.hide();
		}

		const createOrUpdateSettings = () => {
			settingsList.children().forEach((child) => child.dispose());
			settingsList.addChild('ClickableComponent', {
				className: `${this.options_.className}-button-back vjs-visible-text`,
				controlText: 'Back',
				clickHandler: () => {
					settingsList.hide();
					this._settingsNamesContainer.show();
				}
			});

			const itemClassName = `${this.options_.className}-settings-item`;
			items.forEach((item) => {
				const settingsItem = settingsList.addChild('ClickableComponent', {
					controlText: item.name,
					clickHandler: () => {
						item.onClick && item.onClick();
					},
					className: `${itemClassName} vjs-visible-text` + (item.checkSelected() ? ' vjs-selected' : '')
				});
				if (item.checkDisabled()) {
					settingsItem.disable();
				}
				if (item.getRegisterForInfoUpdate) {
					const register = item.getRegisterForInfoUpdate();
					register((text) => {
						settingsItem.el().setAttribute('data-info', text);
					});
				}
				if (item.className) {
					settingsItem.addClass(item.className(itemClassName))
				}
			});
		};
		createOrUpdateSettings();

		return [
			createOrUpdateSettings,
			() => settingsList
		];
	}

	addSettingsName(id, name, getCurrentValue, getSettingsList, componentName) {
		const { text, className: customClassName, onClick } = name;
		const nameComponentClassName = `${this.options_.className}-settings-name`;
		let settingsNameComponent;
		const createOrUpdateSettingsNameComponent = () => {
			if (settingsNameComponent) {
				settingsNameComponent.dispose();
			}
			settingsNameComponent = this._settingsNamesContainer.addChild('ClickableComponent', {
				controlText: text,
				clickHandler: () => {
					if (onClick) {
						onClick();
					} else {
						getSettingsList().show();
						this._settingsNamesContainer.hide();
					}

					if (componentName) {
						this.player().trigger(`${componentName}/click`);
					}
				},
				className: `${nameComponentClassName} vjs-visible-text`
			});
			settingsNameComponent.$('.vjs-control-text').setAttribute('data-value', getCurrentValue());
			settingsNameComponent.setAttribute('data-id', id);

			if (customClassName) {
				settingsNameComponent.addClass(customClassName(nameComponentClassName));
			}
		};
		createOrUpdateSettingsNameComponent();
		return [
			createOrUpdateSettingsNameComponent,
			() => settingsNameComponent
		];
	}

	hide() {
		super.hide();
		if (this.options_.onHide) {
			this.options_.onHide();
		}
	}

	show() {
		super.show();
		if (this.options_.onShow) {
			this.options_.onShow();
		}
	}

	toggle() {
		if (this.hasClass('vjs-hidden')) {
			this.show();
		} else {
			this.hide();
		}
	}
}

export { Popup };
